import React from "react";
import { Row, Col, Card, Typography } from "antd";

import Button from "../../../components/button";

import { LoanCalculationType } from "../../../services/eligibilityService/EligibilityService.type";
import { eligibilityAmountFoldConstants as CONSTANTS } from "./EligibilityAmountFoldConstants";
import manualCalcImg from "../../../assets/manual-calculation.svg";
import instantCalcImg from "../../../assets/instant-calculation.svg";

const { Text, Title } = Typography;

interface IntermediateScreenProps {
  setFieldValue: (key: string, val: string) => void;
  changeLoanCalculationType: (data: LoanCalculationType) => void;
}

const IntermediateScreen: React.FC<IntermediateScreenProps> = ({
  setFieldValue,
  changeLoanCalculationType
}: IntermediateScreenProps) => (
  <React.Fragment>
    <Row type="flex" className="py-4" gutter={[16, 0]}>
      <Col xs={24} md={11}>
        <Card className="d-flex flex-column intermediate-screen-card instant-calc-card">
          <Title
            level={4}
            className="intermediate-screen-card-title pb-0 pb-lg-2 mb-0 mb-lg-3"
          >
            {CONSTANTS.titles.instantCalculation}
          </Title>
          <Text className="d-block card-secondary-text pt-0 pt-lg-4">
            {CONSTANTS.labels.instantCalcSecondaryText1}
          </Text>
          <img
            src={instantCalcImg}
            alt="instant Calculation"
            className="py-4"
          />
          <Text className="d-block card-secondary-text pb-4 pt-1">
            {CONSTANTS.labels.instantCalcSecondaryText2}
          </Text>
          <Button
            type="primary"
            onClick={() => {
              setFieldValue("loanCalculationType", LoanCalculationType.instant);
              changeLoanCalculationType(LoanCalculationType.instant);
            }}
          >
            {CONSTANTS.labels.intermediateScreenButtonText}
          </Button>
        </Card>
      </Col>
      <Col
        md={2}
        xs={24}
        className="loan-type-or-label d-flex justify-content-center align-items-center pt-3 pt-md-0"
      >
        <Title level={3}>{CONSTANTS.labels.loanTypeOrLabel}</Title>
      </Col>
      <Col xs={24} md={11}>
        <Card className="d-flex flex-column intermediate-screen-card">
          <Title
            level={4}
            className="intermediate-screen-card-title pb-0 pb-lg-2 mb-0 mb-lg-3"
          >
            {CONSTANTS.labels.manualFileUpload}
          </Title>
          <Text className="d-block card-secondary-text pt-0 pt-lg-4">
            {CONSTANTS.labels.manualFileSecondaryText1}
          </Text>
          <img src={manualCalcImg} alt="instant Calculation" className="py-4" />
          <Text className="d-block card-secondary-text pb-4">
            {CONSTANTS.labels.manualFileSecondaryText2}
          </Text>
          <Button
            onClick={() => {
              setFieldValue("loanCalculationType", LoanCalculationType.manual);
              changeLoanCalculationType(LoanCalculationType.manual);
            }}
          >
            {CONSTANTS.labels.intermediateScreenButtonText}
          </Button>
        </Card>
      </Col>
    </Row>
  </React.Fragment>
);

export default IntermediateScreen;
